"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserUpdate = exports.UserUpdateContext = exports.useUserMeta = exports.UserContext = void 0;
const react_1 = require("react");
exports.UserContext = (0, react_1.createContext)({});
const useUserMeta = () => (0, react_1.useContext)(exports.UserContext);
exports.useUserMeta = useUserMeta;
exports.UserUpdateContext = (0, react_1.createContext)({});
const useUserUpdate = () => (0, react_1.useContext)(exports.UserUpdateContext);
exports.useUserUpdate = useUserUpdate;
